if (!customElements.get('green24-sticky-purchase')) {
  customElements.define('green24-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.panel = document.getElementById(`G24Purchase-${this.dataset.section}`);
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.panel || !this.form || !this.section) return;
      this.nativeButton = this.form.querySelector('[name="add"]');
      if (!this.nativeButton) return;
      this.quantity = this.querySelector('[data-sticky-quantity]');
      this.button = this.querySelector('[data-sticky-submit]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const mobileEntry = this.section.dataset.g24MobileEntry === 'true' && matchMedia('(max-width: 749px)').matches;
          if (mobileEntry) {
            const buttonBounds = this.nativeButton.getBoundingClientRect();
            this.hidden = buttonBounds.bottom >= 0;
          } else {
            this.hidden = this.panel.getBoundingClientRect().bottom >= 0;
          }
          document.body.classList.toggle('g24-has-sticky-purchase', !this.hidden);
        });
      };
      window.addEventListener('scroll', this.onScroll, { ...options, passive: true });
      window.addEventListener('resize', this.onScroll, options);
      this.panel.addEventListener('input', () => { this.quantityDirty = false; this.sync(); }, options);
      this.panel.addEventListener('change', () => { this.quantityDirty = false; this.sync(); }, options);
      this.quantity.addEventListener('input', () => { this.quantityDirty = true; }, options);
      this.quantity.addEventListener('change', () => this.commitQuantity(), options);
      this.querySelector('[data-sticky-minus]').addEventListener('click', () => this.step(-1), options);
      this.querySelector('[data-sticky-plus]').addEventListener('click', () => this.step(1), options);
      this.button.addEventListener('click', () => {
        if (!this.commitQuantity() || this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') return;
        const recipient = this.form.querySelector('gift-card-recipient-form');
        if (recipient) {
          this.panel.scrollIntoView({ block: 'center' });
          this.panel.focus({ preventScroll: true });
          return;
        }
        this.form.requestSubmit(this.nativeButton);
        this.sync();
      }, options);
      this.querySelector('[data-sticky-change]').addEventListener('click', (event) => {
        event.preventDefault();
        this.panel.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.panel.focus({ preventScroll: true });
      }, options);
      this.observer = new MutationObserver(() => { this.sync(); this.onScroll(); });
      this.observer.observe(this.panel, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'min', 'max', 'step', 'value'] });
      this.sync();
      this.onScroll();
    }
    get nativeQuantity() { return this.panel.querySelector('input[name="quantity"]'); }
    sync() {
      const native = this.nativeQuantity;
      if (native) {
        for (const name of ['min', 'max', 'step']) {
          const value = native.getAttribute(name);
          if (value === null) this.quantity.removeAttribute(name);
          else this.quantity.setAttribute(name, value);
        }
        if (!this.quantityDirty && document.activeElement !== this.quantity) this.quantity.value = native.value;
        this.quantity.disabled = native.disabled;
      } else {
        this.quantity.value = '1';
        this.querySelector('.g24-sticky-purchase__quantity').hidden = true;
      }
      const price = this.panel.querySelector('[id^="price-"]');
      const priceValue = price?.querySelector(price.querySelector('.price--on-sale') ? '.price-item--sale' : '.price-item--regular');
      if (priceValue) this.querySelector('[data-sticky-price]').textContent = priceValue.textContent.trim();
      const unit = price?.querySelector('.unit-price');
      this.querySelector('[data-sticky-unit]').textContent = unit && !unit.classList.contains('hidden') ? unit.textContent.replace(/\s+/g, ' ').trim() : '';
      const variantScript = this.panel.querySelector('variant-selects [data-selected-variant]');
      if (variantScript) {
        try {
          const variant = JSON.parse(variantScript.textContent);
          this.querySelector('[data-sticky-variant]').textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
          const image = this.querySelector('.g24-sticky-purchase__image');
          if (variant?.featured_image?.src && image && image.dataset.variant !== String(variant.id)) {
            image.src = variant.featured_image.src;
            image.removeAttribute('srcset');
            image.dataset.variant = String(variant.id);
          }
        } catch (_) {}
      }
      this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
      this.button.textContent = this.nativeButton.querySelector('span')?.textContent.trim() || this.nativeButton.textContent.trim();
      this.button.setAttribute('aria-busy', String(this.nativeButton.classList.contains('loading')));
      const nativeError = this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      const error = this.querySelector('[data-sticky-error]');
      error.hidden = !nativeError || nativeError.hidden;
      error.textContent = error.hidden ? '' : nativeError.querySelector('.product-form__error-message')?.textContent || '';
      const value = Number(this.quantity.value);
      this.querySelector('[data-sticky-minus]').disabled = this.quantity.disabled || value <= Number(this.quantity.min || 1);
      this.querySelector('[data-sticky-plus]').disabled = this.quantity.disabled || (this.quantity.max !== '' && value >= Number(this.quantity.max));
    }
    commitQuantity() {
      if (!this.quantity.reportValidity()) return false;
      if (this.quantity.value === '' || Number(this.quantity.value) < Number(this.quantity.min || 1)) return false;
      this.quantityDirty = false;
      const native = this.nativeQuantity;
      if (native && native.value !== this.quantity.value) {
        native.value = this.quantity.value;
        native.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.sync();
      return true;
    }
    step(direction) {
      if (direction < 0) this.quantity.stepDown();
      else this.quantity.stepUp();
      this.commitQuantity();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('g24-has-sticky-purchase');
    }
  });
}
